import { createFeatureSelector, createSelector } from '@ngrx/store';

import { trialAdapter, TrialAccountsRequestsState, stateName } from './state';

const getIsLoading = (state: TrialAccountsRequestsState) => state.isLoading;
const getError = (state: TrialAccountsRequestsState) => state.error;
const getFilters = (state: TrialAccountsRequestsState) => state.filters;

const { selectAll } = trialAdapter.getSelectors();

export const selectTrialState = createFeatureSelector<
  TrialAccountsRequestsState
>(stateName);

export const selectIsLoading = createSelector(selectTrialState, getIsLoading);
export const selectIsError = createSelector(selectTrialState, getError);
export const selectRequests = createSelector(selectTrialState, selectAll);
export const selectFilters = createSelector(selectTrialState, getFilters);
